import { CallToAction } from 'components/CallToAction'
import SliderNav from 'components/SliderNav'
import { GatsbyImage, getImage, withArtDirection, ImageDataLike, StaticImage } from 'gatsby-plugin-image'
import React, { useRef,Fragment, useState } from 'react'
import { Listbox, Tab } from '@headlessui/react'
import { heading, section } from './classes'
import investment from './images/investment.png'
import residential from './images/residential.png'
import commercial from './images/commercial.png'
import community from './images/community.png'
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next'
import Image1 from './images/slider2-1.png'
import Image2 from './images/slider2-2.png'
import { SelectorIcon } from '@heroicons/react/outline'
import slugify from 'slugify'


export const defaultMarketData = [
	{
		name: 'Residential',
		subtitle: 'Create a detailed portfolio of tenants, assets, and properties to successfully manage your business. Develop personalized communications and automated procedures to improve efficiency and precision.',
		img: residential,
	},
	{
		name: 'Commercial',
		subtitle: 'A comprehensive property management solution that automates lease administration, simplifies operations and improves portfolio performance with centralized data and reporting.',
		img: commercial,
	},
	{
		name: 'Community Associations',
		subtitle: 'Stay connected with your board members and homeowners by providing instant service through the iCloud-Ready Platform’s built-in communication tools. Our platform is your trusted partner for managing all your HOA and Condo needs.',
		img: community,
	},
	{
		name: 'Investment Management',
		subtitle: 'Enable your general partners to streamline real estate investment management with a robust CRM system for effective fundraising, an automated waterfall distribution tool, a self-service Investor Portal, and more.',
		img: investment,
	},
]

    export default function Markets2({ allHomeMarkets2 = {}, googleImages=[] })  {
        const { img ,homeMarkets2Title = {}, style='',markets,id,enable } = allHomeMarkets2
		// console.log(`allHomeMarkets2 ${JSON.stringify(allHomeMarkets2)}`)
        const marketData = markets || defaultMarketData
           if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
        const { title,  description, subtitle } = homeMarkets2Title
        let cta = allHomeMarkets2?.cta
        if (Array.isArray(cta) && cta.length == 1) cta = cta[0]
        const googleImage = img && googleImages && googleImages[0] && googleImages[0].filter((image) => { if (image.name == img) return image })[0]
        const googleImage2 = img && googleImages && googleImages[1] && googleImages[1].filter((image) => { if (image.name == img) return image })[0]
        const gatsbyImage = googleImage && getImage(googleImage)
        const gatsbyImage2 = googleImage2 && getImage(googleImage2)
        const [current, setCurrent] = useState(marketData[0])
        const { i18n } = useTranslation()
        const handleChange = (id) => { setCurrent(marketData.find(item => item.name == id)) }
		const getGatsbyImg  = (imageName) => {
			const googleImage = imageName && googleImages && googleImages[0] && googleImages[0].filter((image) => { if (image.name == imageName) return image })[0]
			const gatsbyImage = googleImage && getImage(googleImage)
			return gatsbyImage
		}

	return (
		<div>
			{i18n.language === 'ar' ? (
				<div className="provenApproach2" style={{ padding: '10px 0', minHeight: 'unset' }}>
					<div className="imgContainer2">
						<img
							src={Image1}
							alt="IMG"
							className="img1"
							style={{ width: '280px', height: '280px' }}
						/>
						<img src={Image2} alt="IMG" className="img2" style={{ width: '60%' }} />
					</div>
					<div className="infoSection2">
						<h2 dir="rtl">نظام إدارة الأملاك</h2>
						<ul dir="rtl">
							<li>تسجيل بيانات المستأجرين بدقة و تفصيل سواء كانو افراد او شركات </li>
							<li>
								الربط الكامل مع نظام القيمة المضافة و احتسابها وفقا للنشاط سواء
								تجارى او سكنى
							</li>
							<li>النظام يتيح طباعه عقود الايجار الخاصة بالمؤسسة </li>
							<li>يمكنك التحصيل من من العملاء وفقا لنوع التحصيل</li>
							<li>ضم و فك الوحدات بسهولة </li>
							<li>الربط الكامل مع الحسابات العامة</li>
							<li>يمكن التعديل على العقود بسهولة </li>
							<li>يمكنك الاطلاع على التقارير التحليلية بالتفاصيل</li>
							<li>
								يدعم النظام اصدار العقود وتحصيل الدفعات بتاريخ ميلادي او هجري
								(ام القرى) .
							</li>
						</ul>
					</div>
				</div>
			) : (
                <div className="market2">
                <div className="marketImges2">
				<GatsbyImage alt={current?.name} image={getGatsbyImg(current?.img)} />
            </div>
            <div className="marketInfo2">
                <h2>
                    Keep your Portfolio <br /> of Homes and Apartments <br /> in One Single
                    Database
                </h2>
                {marketData?.length > 1 ? (
                    <div className="flex items-center ml-10">
                        <Listbox value={current} onChange={(language) => handleChange(language)}>
                            <Listbox.Button className="flex items-center font-bold text-[20px]  lg:text-[30px] space-x-1.5 text-gray">
                                <span>
                                    {current?.name
                                    }
                                </span>

                                <SelectorIcon className="w-4 h-4" />
                            </Listbox.Button>
                            <Listbox.Options className="absolute z-10 w-full bg-[#f8f8f8] text-[#02244d] mt-1 py-1  border border-gray/30 overflow-auto text-base dark:bg-gray-accent-dark dark:text-white rounded shadow-lg max-h-60 focus:outline-none sm:text-sm list-none p-0">
						{ marketData.map((option, index) => {
						return (

                                    <Listbox.Option
                                        key={index}
                                        value={option.name}
                                        className="cursor-pointer text-sm hover:bg-red w-full pl-8 pr-2 py-0.5"
                                    >
                                        {option.name}
                                    </Listbox.Option>
                                                       )
													})}
                            </Listbox.Options>
                        </Listbox>
                    </div>
                ) : null}
						<p>{current?.subtitle}</p>
					</div>
                    </div>)}
		</div>
	)
}
